import {
  ADD_POSITION,
  DELETE_POSITION,
  GET_POSITIONS,
  POSITION_ERROR,
  UPDATE_POSITION,
  SELECT_POSITIONS,
} from 'src/actions/types'

const initialState = {
  positions: {
    data: [],
    current_page: 1,
  },
  positionOptions: [],
  filters: {},
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_POSITIONS:
      return {
        ...state,
        positions: payload.data,
        filters: payload.filters,
        loading: false,
      }
    case ADD_POSITION:
      return {
        ...state,
        positions: { ...state.positions, data: [payload, ...(state.positions.data || [])] },
        loading: false,
      }
    case UPDATE_POSITION: {
      return {
        ...state,
        positions: {
          ...state.positions,
          data: (state.positions.data || []).map((position) =>
            position.id === payload.id ? { ...position, ...payload } : position,
          ),
        },
        loading: false,
      }
    }
    case DELETE_POSITION:
      return {
        ...state,
        positions: {
          ...state.positions,
          data: (state.positions.data || []).filter((position) => position.id !== payload),
        },
        loading: false,
      }
    case SELECT_POSITIONS:
      return {
        ...state,
        positionOptions: Array.isArray(payload) ? payload : [],
      }
    case POSITION_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }
    default:
      return state
  }
}
